'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createConnector = require('../core/createConnector');

var _createConnector2 = _interopRequireDefault(_createConnector);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getId() {
  return 'query';
}

function getCurrentRefinement(props, searchState) {
  var id = getId();
  if (typeof searchState[id] !== 'undefined') {
    return searchState[id];
  }
  if (typeof props.defaultRefinement !== 'undefined') {
    return props.defaultRefinement;
  }
  return '';
}

/**
 * connectSearchBox connector provides the logic to build a widget that will
 * let the user search for a query.
 * @name connectSearchBox
 * @kind connector
 * @providedPropType {function} refine - a function to remove a single filter
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 * @providedPropType {string} currentRefinement - the query to search for.
 */

var _default = (0, _createConnector2.default)({
  displayName: 'AlgoliaSearchBox',

  propTypes: {
    defaultRefinement: _react.PropTypes.string
  },

  getProvidedProps: function getProvidedProps(props, searchState) {
    return {
      currentRefinement: getCurrentRefinement(props, searchState)
    };
  },
  refine: function refine(props, searchState, nextQuery) {
    var id = getId();
    return _extends({}, searchState, _defineProperty({}, id, nextQuery));
  },
  cleanUp: function cleanUp(props, searchState) {
    return (0, _omit3.default)(searchState, getId());
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    return searchParameters.setQuery(getCurrentRefinement(props, searchState));
  }
});

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getId, 'getId', 'src/connectors/connectSearchBox.js');

  __REACT_HOT_LOADER__.register(getCurrentRefinement, 'getCurrentRefinement', 'src/connectors/connectSearchBox.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/connectors/connectSearchBox.js');
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/connectors/connectSearchBox.js
// module id = 524
// module chunks = 0